// Angular DOM
// Angular Hooks
import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
// Redux Store
import { Store } from "@ngrx/store";
import { SetPatientAction, SetTestOrderDetails } from "../../actions";
// Models
import { Patient, TestOrder } from "../../models";
// Third Party services
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, NavigationExtras, Router } from "@angular/router";
// Services
import { AuthService, PatientService, UtilService } from "../../services";
import { Location } from "@angular/common";
import { Subscription } from "rxjs/Subscription";
import { SystemService } from "../../services/system/system.service";
import { PaymentTypes, System } from "../../models/system.model";
import * as ENV from "../../../../environments/environment";
import {FormControl} from "@angular/forms";
import { MatCheckbox } from '@angular/material';

@Component({
  selector: "app-patient-billing-modal",
  templateUrl: "./patient-billing-modal.component.html",
  styleUrls: ["./patient-billing-modal.component.scss"],
})
export class PatientBillingNewModalComponent
  implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild("content") template: TemplateRef<any>;
  public zoom=.8;
  public date = new Date(); // today
  public hipaaCheckBox:boolean;
  public systemId: string;
  public redirect: string;
  public hippaFormUrl: string;
  public hippaFormId: string;
  public patient: Patient;
  public modalRef: any;
  public confirm: boolean = false;
  public subscription: Subscription[] = [];
  public editMode: boolean = false;
  public backButtonText: string = "BACK";
  public modalTitle: string = "Add Patient Billing";
  public isOfficeStaff: boolean;
  public user: User;
  public requestPending: boolean = false;
  public paymentOptions: string[] = [
    "Insurance",
    "Patient Self Pay",
    "Client Bill",
  ];
  public consentToDraw = false;
  public apiPaymentTypes: PaymentTypes = {
    InsuranceBillable: "0",
    ClientBillable: "0",
    SelfPayable: "0",
  };
  public currentSystem: any = {};

  public systemName: string;
  private modalOptions: NgbModalOptions = {
    backdrop: "static",
    windowClass: "patient-billing",
    container: "app-patient-billing-modal",
    keyboard: false,
  };
  showHippa = false;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    private authService: AuthService,
    private modalService: NgbModal,
    private patientService: PatientService,
    private store: Store<any>,
    private utilService: UtilService,
    private location: Location,
    private systemService: SystemService
  ) {}

  cancel() {
    this.store.dispatch({ type: "CLEAR_PATIENT" });
    this.store.dispatch({ type: "CLEAR_TEST_ORDER" });
    this.router.navigate(["/patients"]);
  }

  ngOnInit() {
    let system_id = "";
    this.user = this.authService.getUser();
    this.isOfficeStaff = false; // this.user.Role === "staff";

    this.subscription["userSession"] = this.store.select("userSession").subscribe((userSession) => {
      system_id = userSession.Facility.System.Id;
      this.systemId = system_id
      this.systemName = userSession.Facility.System.Name;
    });

    this.subscription["patient"] =  this.store.select("patient").subscribe((patient) => {
      this.patient = Object.assign({}, new Patient(), patient);
    });

    this.subscription["getSystemsById"] = this.systemService
      .getSystemById(system_id)
      .subscribe((response) => {
        const hippa = response.Attachments.filter(e=>e.TagList.find(e=>e == "hipaa")!== undefined);
        this.showHippa = hippa.length > 0 ? true : false;
        this.hippaFormUrl = hippa.length > 0 ? hippa[0].FileUrl : "";
        this.hippaFormId = hippa.length > 0 ? hippa[0].Id : "";
        this.apiPaymentTypes = response.PaymentTypes;
        this.currentSystem = response;
      });
  }

  incrementZoom(amount: number) {
    this.zoom += amount;   
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.modalRef = this.modalService.open(this.template, this.modalOptions);
    });
  }

  ngOnDestroy() {
    setTimeout(() => {
      this.modalRef.close();
    });
    this.subscription.forEach((sub) => {
      sub.unsubscribe();
    });
  }

  onFacilitySelect(event, elem) {
    this.patient.BillToText = event;
    this.patient.InsurancePolicies[0].BillTo = "";
    elem.focus();
  }

  onFacilityRadioButton(elem) {
    this.patient.InsurancePolicies[0].BillTo = "";
    elem.focus();
  }

  clearFacilityField() {
    this.patient.BillToText = "";
  }

  onSelectAccountClientBill() {
    if (this.apiPaymentTypes && this.apiPaymentTypes.ClientBillable === "1") {
      this.patient.BillToText = this.systemName + " " + "Client Bill";
      this.patient.InsurancePolicies[0].BillTo = this.patient.BillToText;
    }
  }

  isConsentToDrawChecked($event) {
   this.consentToDraw = $event;
  }

  setConfirm() {}

  canSkip() {
    return (
      !(
        this.patient.BillToText ||
        this.patient.InsurancePolicies[0].BillTo ||
        this.patient.InsurancePolicies[0].Provider ||
        this.patient.InsurancePolicies[0].GroupNumber ||
        this.patient.InsurancePolicies[0].PlanNumber
      ) && !this.isOfficeStaff
    );
  }
  checkFormValidity(form) {
    return form.invalid;
  }

  back() {
    this.location.back();
  }

  update() {
    // Cleint Bill
    if (this.patient.InsurancePolicies[0].BillTo.includes(this.paymentOptions[2])) {
      this.patient.InsurancePolicies[0].Name = this.patient.BillToText;
      // Insurance
    } else if (
      this.patient.InsurancePolicies[0].BillTo === this.paymentOptions[0]
    ) {
      this.patient.InsurancePolicies[0].Name = this.patient.InsurancePolicies[0].Provider;

      // Patient Self Pay
    } else if (
      this.patient.InsurancePolicies[0].BillTo === this.paymentOptions[1]
    ) {
      this.patient.InsurancePolicies[0].Name = this.paymentOptions[1];
    }
    this.requestPending = true;

    if(this.hipaaCheckBox)
    {
      this.patient.HipaaFormId = this.hippaFormId;
    }

    this.subscription["createPatient"] = this.patientService.createPatient(this.patient).subscribe(
      (createdPatient) => {
        this.requestPending = false;
        this.patient.Id = createdPatient.Id;

        this.store.dispatch(
          new SetPatientAction(this.patient, this.utilService)
        );
        if (this.redirect !== "") {
          let testOrder: TestOrder = new TestOrder();
          testOrder.PatientName = `${createdPatient.FirstName}${
            createdPatient.MiddleName ? ` ${createdPatient.MiddleName} ` : " "
          }${createdPatient.LastName}`;
          testOrder.PatientDob = createdPatient.Dob;
          testOrder.PatientId = createdPatient.Id;
          this.store.dispatch(
            new SetTestOrderDetails(testOrder, this.utilService)
          );
        }

        let navigationExtras: NavigationExtras = {
          queryParams: { redirect: this.redirect, fromStore: true },
        };
        this.router.navigate(["/home/create/success"], navigationExtras);
      },
      (err) => {
        this.requestPending = false;
        this.router.navigate(["/home/create/failure"]);
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/patient-billing-modal/patient-billing-new-modal.component.ts